import { render, staticRenderFns } from "./BudgetManagmentServices.vue?vue&type=template&id=1e56f148"
import script from "./BudgetManagmentServices.vue?vue&type=script&lang=js"
export * from "./BudgetManagmentServices.vue?vue&type=script&lang=js"
import style0 from "./BudgetManagmentServices.vue?vue&type=style&index=0&id=1e56f148&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports